import moment from "moment";
import { useEffect, useState } from "react";

import { getNewMembers } from "../../lib/discordQueries";
import { NewMembers, TimePeriod } from "../../lib/discordTypes";

const defaultTimeFormat = "MM/DD/YY";

/**
 * Loads new Discord members grouped by week or month for a given time period
 * @param startTime start of period
 * @param endTime end of period
 * @param timePeriod "week" or "month"
 * @returns
 * loading: wether thehook is loading
 * membersMonth: a list of new members count grouped by month
 * membersWeek: a listo of new mwmbers coun grouped by week
 */
function useNewMembersPeriod(
  startTime: string,
  endTime: string,
  timePeriod: TimePeriod
) {
  const [membersMonth, setMembersMonth] = useState<NewMembers[]>([]);
  const [membersWeek, setMembersWeek] = useState<NewMembers[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  /**
   * Loads new Discord members grouped by week or month
   */
  const loadNewMembers = async () => {
    setLoading(true);
    const params = {
      startTime: moment(startTime).format(defaultTimeFormat),
      endTime: moment(endTime).format(defaultTimeFormat),
      timePeriod,
    };
    const members = await getNewMembers(
      params.startTime,
      params.endTime,
      params.timePeriod
    );
    if (timePeriod === "month") {
      setMembersMonth(members);
    } else {
      setMembersWeek(members);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadNewMembers();
  }, [startTime, endTime, timePeriod]);

  return {
    loading,
    membersMonth,
    membersWeek,
  };
}

export default useNewMembersPeriod;
